export default "/fcbcac1db17390110677298f9d30eeed9c121039/a70fe28c30edbe909cade8425716fdee.svg";